<template>
  <v-card :loading="loading">
    <v-card-text class="pa-2 caption black--text">
      <apexchart type="bar" :height="height" :options="chartOptions" :series="series" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          stackType: '100%',
          events: {
            dataPointSelection: this.dataPointSelection
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        colors: ['#F44336', '#FF9800', '#FFEB3B', '#4CAF50'],
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        title: {
          text: 'Feedback reactions'
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val
            }
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40
        },
        dataLabels: {
          style: {
            colors: ['white', 'white', 'black', 'white']
          }
        }
      }
    }
  },
  async mounted () {
    await this.getStatistic()
  },
  computed: {
    height () {
      return Math.max(150 + this.chartOptions.xaxis.categories.length * 20, 300)
    }
  },
  watch: {
    async '$route.query' () {
      await this.getStatistic()
    }
  },
  methods: {
    async getStatistic () {
      if (!this.$route.query.build_id) {
        return
      }

      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/telemetry/feedback-chart-data`, {
          params: {
            build_id: this.$route.query.build_id
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.series = data.series
        this.chartOptions = {
          ...this.chartOptions,
          xaxis: {
            categories: data.categories
          }
        }
      }
      this.loading = false
    },
    dataPointSelection (event, chartContext, opts) {
      const { dataPointIndex, seriesIndex } = opts
      const reaction = this.series[seriesIndex].name
      const category = this.chartOptions.xaxis.categories[dataPointIndex]

      this.$eventBus.$emit('feedback-chart-data-point-selected', {
        reaction,
        category
      })
    }
  }
}
</script>

<style scoped>
  .align-top {
    vertical-align: top;
  }
</style>